/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Open_PropertyInputs */

const cs_messages_open_property = /** @type {(inputs: Messages_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitost`)
};

const en_messages_open_property = /** @type {(inputs: Messages_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open listing`)
};

/**
* | output |
* | --- |
* | "Open listing" |
*
* @param {Messages_Open_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_open_property = /** @type {((inputs?: Messages_Open_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Open_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_open_property(inputs)
	return cs_messages_open_property(inputs)
});